module.exports = __webpack_public_path__ + "static/media/lend.91e3bfc1.svg";